import { create } from "zustand";
import { combine } from "zustand/middleware";

type RechargeSteps = "selectRechargeValue" | "waitForPayment" | "success";

const initialState = {
  isOpen: false,
  step: "selectRechargeValue" as RechargeSteps,
  rechargeId: null as string | null,
  qrCode: null as string | null,
  payload: null as string | null,
};

export const useRechargeDialogStore = create(
  combine(
    {
      isOpen: false,
      step: "selectRechargeValue" as RechargeSteps,
      rechargeId: null as string | null,
      qrCode: null as string | null,
      payload: null as string | null,
    },

    (set) => ({
      open: () => set({ ...initialState, isOpen: true }),
      close: () => set({ ...initialState }),
      toggle: () => set((state) => ({ isOpen: !state.isOpen })),
      setIsOpen: (isOpen: boolean) => set({ isOpen }),
      setStep: (step: RechargeSteps) => set({ step }),
      setRechargeId: (rechargeId: string) => set({ rechargeId }),
      setQrCode: (qrCode: string) => set({ qrCode }),
      setPayload: (payload: string) => set({ payload }),
    }),
  ),
);
